import styled from 'styled-components';
import { sx2CssThemeFn, SxStyleProp } from '@hotelplan/util.theme.sxc';
import { WhiteBoxModal } from '@hotelplan/components.common.modals';
import { FdrRoute } from '@hotelplan/fdr.regular.basis.fdr-route';

export const FdrCO2FootprintWrapper = styled.div<{ isB2B: boolean }>(
  ({ isB2B }) =>
    sx2CssThemeFn({
      bg: 'paperGrey',
      mb: !isB2B && ['50px', 9],
    })
);

export const FdrCO2FootprintHeaderDesktopWrapper = styled.div(
  sx2CssThemeFn({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 9,
    p: '40px',
  })
);

export const FdrCO2FooterDesktopWrapper = styled.div(
  sx2CssThemeFn({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 9,
    pb: 5,
  })
);

export const FdrCO2LoadMoreButtonWrapper = styled.div<{ isShow: boolean }>(
  ({ isShow }) =>
    sx2CssThemeFn({
      width: 'fit-content',
      opacity: isShow ? 1 : 0,
      a: {
        cursor: !isShow && 'default',
      },
      pt: '20px',
      transition: 'opacity 0.5s ease',
    })
);

export const FdrCO2LoadMoreButtonWrapperDesktop = styled(
  FdrCO2LoadMoreButtonWrapper
)(
  sx2CssThemeFn({
    pt: '20px',
  })
);

export const FdrCO2LoadMoreButtonWrapperMobile = styled(
  FdrCO2LoadMoreButtonWrapper
)(({ isShow }) =>
  sx2CssThemeFn({
    position: isShow ? 'initial' : 'absolute',
    bottom: '-20px',
    pt: 2,
  })
);

export const FdrCO2FootprintTotalEmissionWrapper = styled.div<{
  isShow: boolean;
}>(({ isShow }) =>
  sx2CssThemeFn({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: isShow && 'pointer',
    border: '2px solid',
    borderColor: 'greenOlive',
    bg: 'white',
    px: 3,
    py: 2,
    '.icon': {
      flexShrink: 0,
      mr: 4,
      width: '48px',
      height: '48px',
      fill: 'white',
      color: 'black',
    },
    fontSize: 3,
    lineHeight: '32px',
    span: {
      fontSize: 1,
      lineHeight: '22px',
    },
  })
);

const FdrCO2FootprintBodyWrapper = styled.div<{
  isOpen: boolean;
  bodyHeight: number;
}>(({ isOpen, bodyHeight }) =>
  sx2CssThemeFn({
    maxHeight: isOpen ? `${bodyHeight}px` : 0,
    overflow: 'hidden',
    transition: '0.5s ease',
    opacity: isOpen ? 1 : 0,
  })
);

export const FdrCO2FootprintBodyWrapperMobile = styled(
  FdrCO2FootprintBodyWrapper
)(
  sx2CssThemeFn({
    px: '20px',
  })
);

export const FdrCO2FootprintBodyWrapperDesktop = styled(
  FdrCO2FootprintBodyWrapper
)(
  sx2CssThemeFn({
    px: '40px',
  })
);

export const FdrCO2FootprintBodyInnerDesktop = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  })
);

export const FdrCO2FootprintBodyInnerMobile = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  })
);

export const FdrCO2FootprintContentWrapper = styled.div(
  sx2CssThemeFn({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 9,
  })
);

export const FdrCO2CloseButtonWrapper = styled.div(
  sx2CssThemeFn({
    width: 'fit-content',
    '.icon': {
      transform: 'rotate(180deg)',
    },
  })
);

export const FdrCO2CloseButtonWrapperMobile = styled.div(
  sx2CssThemeFn({
    py: 5,
    width: 'fit-content',
    '.icon': {
      transform: 'rotate(180deg)',
    },
  })
);

export const FdrCO2FootprintTitle = styled.h3(
  sx2CssThemeFn({
    fontSize: '15px',
    fontWeight: 700,
    color: 'redBurgundy',
    textTransform: `uppercase`,
  })
);

export const FdrCO2ModalMainText = styled.div(
  sx2CssThemeFn({
    fontSize: 2,
    lineHeight: '26px',
    p: {
      pt: 2,
      '&:first-of-type': {
        pt: 0,
      },
    },
    a: {
      display: 'inline',
      textDecoration: 'underline',
    },
  })
);

export const FdrCO2EmissionWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
  })
);

export const FdrCO2EmissionWrapperDesktop = styled(FdrCO2EmissionWrapper)(
  sx2CssThemeFn({
    pb: 5,
  })
);

export const FdrCO2FootprintMoreInfoStyles: SxStyleProp = {
  display: 'flex',
  cursor: 'pointer',
  textDecoration: 'underline',
  '.icon': {
    width: '24px',
    height: '24px',
    mr: '16px',
    color: 'redWeb',
  },
};

const FdrCO2FootprintMoreInfo = styled.div(
  sx2CssThemeFn(FdrCO2FootprintMoreInfoStyles)
);

export const FdrCO2FootprintMoreInfoDesktop = styled(FdrCO2FootprintMoreInfo)(
  sx2CssThemeFn({
    justifyContent: 'flex-end',
    fontWeight: 'bold',
  })
);

export const FdrCO2FootprintMoreInfoMobile = styled(FdrCO2FootprintMoreInfo)(
  sx2CssThemeFn({
    justifyContent: 'flex-end',
    pt: 4,
  })
);

export const FdrCO2DescriptionTextMain = styled.div(
  sx2CssThemeFn({
    pt: 2,
    fontSize: 3,
    lineHeight: '32px',
    p: {
      pt: 2,
    },
    a: {
      textDecoration: 'underline',
    },
  })
);

export const FdrCO2DescriptionTextSub = styled.div(
  sx2CssThemeFn({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr 1fr'],
    gap: [0, 9],
    pt: [3, 6],
    mt: [3, 0],
    fontSize: 1,
    p: {
      pt: [2, 0],
    },
    a: {
      textDecoration: 'underline',
    },
    borderTop: '1px solid lightGrey',
  })
);

export const FdrCO2EmissionListWrapper = styled.div<{ isBlocks: boolean }>(
  ({ isBlocks }) =>
    sx2CssThemeFn({
      display: 'flex',
      alignItems: 'start',
      gap: '12px',
      pt: '20px',
      flexWrap: [isBlocks ? 'wrap' : 'nowrap', 'nowrap'],
    })
);

export const FdrCo2EmissionItemWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '45%',
    gap: '10px',
    bg: 'white',
    width: '100%',
    pt: '12px',
    pb: 3,
    '.icon': {
      flexShrink: 0,
      width: '48px',
      height: '48px',
      fill: 'white',
      color: 'black',
    },
  })
);

export const FdrCo2EmissionItemPercentage = styled.span(
  sx2CssThemeFn({
    fontSize: 3,
    lineHeight: '32px',
  })
);

export const FdrCo2EmissionItemCaption = styled.span(
  sx2CssThemeFn({
    fontSize: 1,
    lineHeight: '22px',
  })
);

export const FdrCO2FootprintModalDesktop = styled(WhiteBoxModal)(
  sx2CssThemeFn({
    '.modal-wrapper': {
      maxHeight: '95vh',
      width: '660px',
    },
    '.modal-header': {
      px: 4,
      py: '10px',
      fontSize: '24px',
      borderColor: 'lightGrey',
    },
    '.modal-body': {
      p: 4,
    },
  })
);

export const FdrCO2FootprintModalMobile = styled(WhiteBoxModal)<{
  windowHeight: string;
  animateModal: boolean;
}>(({ windowHeight, animateModal }) =>
  sx2CssThemeFn({
    '.modal-wrapper': {
      maxHeight: windowHeight ? windowHeight : 'auto',
      transition: '0.5s ease',
      transform: `translateY(${animateModal ? 0 : windowHeight || 0})`,
      borderRadius: 0,
    },
    '.modal-header': {
      px: 4,
      py: '10px',
      fontSize: 4,
      borderColor: 'lightGrey',
    },
    '.modal-body': {
      p: '24px 20px',
    },
    '.shadow-overlay': {
      transition: '0.5s ease',
      bg: animateModal ? 'modalShadow' : 'rgba(0, 0, 0, 0.0)',
    },
  })
);

export const FdrCO2FootprintContact = styled(FdrRoute)(
  sx2CssThemeFn({
    ...FdrCO2FootprintMoreInfoStyles,
    alignSelf: 'flex-end',
    pt: '40px',
    '&:hover': {
      color: 'initial',
    },
  })
);

export const FdrCo2AdditionalInfoWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '40px',
    gap: '40px',
    fontSize: [2, 3],
    lineHeight: ['26px', '32px'],
    '> div': {
      borderBottom: '1px solid',
      borderColor: 'lightGrey',
      paddingBottom: 4,
    },
  })
);

export const CO2FootprintHeaderMobileWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    p: '40px 16px 32px 16px',
    position: 'relative',
  })
);
